
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subsets/cellosaurus-subsets",
      function () {
        return require("private-next-pages/subsets/cellosaurus-subsets.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subsets/cellosaurus-subsets"])
      });
    }
  